.form-body {
    width: 250px;
    overflow-y: auto;
}

.form-body ul {
    height: auto;
    max-height: 300px;
}
